<!--首页-->
<template>
	<div class="jdqs_content" id="homeCont">
		<div class="header">
			<a class="logo" :href="'http://xubei.com?gameid=245&channel=' + channel" target="_blank">
				<img src="/static/images/lol/logo.png" />
			</a>
		</div>
		<div class="banner">
			<div class="leftdiv">
				<div class="tu1"><img src="/static/images/lol/tubiao.png" /></div>
				<div class="tu2"><img src="/static/images/lol/ewm.png" /></div>
			</div>
			<a class="rightdiv" :href="'http://new.xubei.com/shopList.html?gameid=245&channel=' + channel" target="_blank">
				<img src="/static/images/lol/wz.png" />
			</a>
		</div>
		<div class="swBanner">
			<a :href="'http://new.xubei.com/shopList.html?gameid=245&channel=' + channel" target="_blank">
				<img src="/static/images/lol/swbanner.png" />
			</a>
		</div>

		<div class="ucontent">
			<!-- <div class="swlist">
            <a :href="'http://new.xubei.com/shopList.html?gameid=245&channel='+channel" target="_blank"><img src="/static/images/lol/swBtn.png"/></a>  
            <a :href="'http://new.xubei.com/shopList.html?gameid=245&channel='+channel" target="_blank"><img src="/static/images/lol/swBtn.png"/></a>  
            <a :href="'http://new.xubei.com/shopList.html?gameid=245&channel='+channel" target="_blank"><img src="/static/images/lol/swBtn.png"/></a>  
            <a :href="'http://new.xubei.com/shopList.html?gameid=245&channel='+channel" target="_blank"><img src="/static/images/lol/swBtn.png"/></a>  
          </div> -->
			<div class="more_game"><img src="/static/images/lol/more_game.png" /></div>
			<div class="steam_game">
				<div class="steam_list">
					<a
						class="item"
						:href="'http://new.xubei.com/shopList.html?gameid=1494&userId=472474&channel=' + channel"
						target="_blank"
					>
						<div><img src="/static/images/lol/t1.png" /></div>
						<div class="cn">
							<div class="tit">绝地求生</div>
							<div class="hao">
								<span>高段号</span>
								<span>鱼塘号</span>
							</div>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=302&channel=' + channel" target="_blank">
						<div><img src="/static/images/lol/t2.png" /></div>
						<div class="cn">
							<div class="tit">穿越火线</div>
							<div class="hao"><span>生化爆破全装百v号</span></div>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=245&channel=' + channel" target="_blank">
						<div><img src="/static/images/lol/t3.png" /></div>
						<div class="cn">
							<div class="tit">英雄联盟</div>
							<div class="hao">
								<span>满英雄</span>
								<span>稀有皮肤号</span>
							</div>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=588&channel=' + channel" target="_blank">
						<div><img src="/static/images/lol/t4.png" /></div>
						<div class="cn">
							<div class="tit">逆战</div>
							<div class="hao">
								<span>创世套</span>
								<span>塔防全装</span>
							</div>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a
						class="item"
						:href="'http://new.xubei.com/shopList.html?gameid=592&channel=' + channel"
						target="_blank"
						style="margin-right: 0"
					>
						<div><img src="/static/images/lol/t5.png" /></div>
						<div class="cn">
							<div class="tit">QQ飞车</div>
							<div class="hao"><span>全29T3 高改雷诺</span></div>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>
				</div>

				<div class="steam_list">
					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=587&channel=' + channel" target="_blank">
						<div><img src="/static/images/lol/t6.png" /></div>
						<div class="cn">
							<div class="tit">守望先锋</div>
							<div class="hao">
								<span>金武器</span>
								<span>超多皮肤</span>
							</div>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=1863&channel=' + channel" target="_blank">
						<div><img src="/static/images/lol/t7.png" /></div>
						<div class="cn">
							<div class="tit">问道</div>
							<div class="hao">
								<span>改8满宠</span>
								<span>满法宝</span>
							</div>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=2147&channel=' + channel" target="_blank">
						<div><img src="/static/images/lol/t8.png" /></div>
						<div class="cn">
							<div class="tit">武侠义</div>
							<div class="hao"><span>中国风武侠版吃鸡</span></div>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=1850&channel=' + channel" target="_blank">
						<div><img src="/static/images/lol/t9.png" /></div>
						<div class="cn">
							<div class="tit">生死狙击</div>
							<div class="hao">
								<span>60+英雄</span>
								<span>100+黄金</span>
							</div>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a
						class="item"
						:href="'http://new.xubei.com/shopList.html?gameid=1851&channel=' + channel"
						target="_blank"
						style="margin-right: 0"
					>
						<div><img src="/static/images/lol/t10.png" /></div>
						<div class="cn">
							<div class="tit">反恐精英OL</div>
							<div class="hao">
								<span>弑神双剑</span>
								<span>鸡神永恒</span>
							</div>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>
				</div>

				<div class="steam_list">
					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=1109&channel=' + channel" target="_blank">
						<div><img src="/static/images/lol/t11.png" /></div>
						<div class="cn">
							<div class="tit">王者荣耀</div>
							<div class="hao">
								<span>全英雄</span>
								<span>稀有皮肤</span>
							</div>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=1822&channel=' + channel" target="_blank">
						<div><img src="/static/images/lol/t12.png" /></div>
						<div class="cn">
							<div class="tit">穿越火线：枪战王者</div>
							<div class="hao"><span>生化爆破全装百V号</span></div>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=1838&channel=' + channel" target="_blank">
						<div><img src="/static/images/lol/t13.png" /></div>
						<div class="cn">
							<div class="tit">QQ飞车手游</div>
							<div class="hao">
								<span>主播号</span>
								<span>至尊V9</span>
							</div>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a class="item" :href="'http://new.xubei.com/shopList.html?gameid=1522&channel=' + channel" target="_blank">
						<div><img src="/static/images/lol/t14.png" /></div>
						<div class="cn">
							<div class="tit">球球大作战 </div>
							<div class="hao">
								<span>10W皮</span>
								<span>130秀</span>
							</div>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>

					<a
						class="item"
						:href="'http://new.xubei.com/shopList.html?gameid=1525&channel=' + channel"
						target="_blank"
						style="margin-right: 0"
					>
						<div><img src="/static/images/lol/t15.jpg" /></div>
						<div class="cn">
							<div class="tit">火影忍者</div>
							<div class="hao">
								<span>10S</span>
								<span>战力700万</span>
							</div>
						</div>
						<a class="sw_btn">
							1元试玩
							<i></i>
						</a>
					</a>
				</div>
			</div>
		</div>

		<div class="footer">
			<div class="cont">
				<div class="c1">
					Copyright © 2015-2016 杭州诸相网络科技有限公司 (www.xubei.com) 版权所有 浙ICP备15021515号-1
				</div>
				<div class="c2">
					<div class="hz">
						<span>QQ客服：800055370</span>
						<span>商务合作：taomin@xubei.com</span>
					</div>
					<div class="yz">
						<a href="http://webscan.360.cn/index/checkwebsite?url=www.xubei.com" target="_blank">
							<img src="/static/images/lol/an1.png" class="img1" />
						</a>
						<a href="https://www.alipay.com/" target="_blank"><img src="/static/images/lol/an2.png" class="img2" /></a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'jdwb',
	components: {},
	data: function () {
		return {
			channel: this.$route.query.channel || ''
		};
	},
	mounted() {},
	methods: {}
};

var _hmt = _hmt || [];
(function () {
	var hm = document.createElement('script');
	hm.src = 'https://hm.baidu.com/hm.js?cdea94c5bc45d355e2a3ab8d8664de0d';
	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(hm, s);
})();
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
.jdqs_content {
	width: 100%;
	height: 100%;
	background: #fff url(/static/images/lol/bg.jpg) no-repeat;
	background-size: 100% 100%;
	.header {
		background: #261620;
		opacity: 0.8;
		.logo {
			width: 1200px;
			margin: 0 auto;
			padding: 7px 0;
			display: block;
			img {
				width: 182px;
				height: 34px;
			}
		}
	}
	.banner {
		width: 1200px;
		margin: 0 auto;
		overflow: hidden;
		.leftdiv {
			float: left;
			.tu1 {
				margin-top: 30px;
				img {
					width: 122px;
					height: 64rpx;
				}
			}
			.tu2 {
				margin-top: 93px;
				margin-bottom: 100px;
				img {
					width: 199px;
					height: 200px;
				}
			}
		}
		.rightdiv {
			display: block;
			float: right;
			margin-top: 50px;
		}
	}
	.ucontent {
		width: 1200px;
		height: 1071px;
		margin: 0 auto;
		color: #fff;
		overflow: hidden;
		background: url(/static/images/lol/border.png) no-repeat;
		.more_game {
			text-align: center;
			margin-top: 22px;
			img {
				width: 299px;
				height: 126px;
			}
		}
		.swlist {
			padding-top: 580px;
			a {
				display: block;
				float: left;
				width: 25%;
				text-align: center;
				img {
					width: 216px;
					height: 68px;
				}
			}
		}
		.swBanner {
			a {
				display: block;
				img {
					width: 1891px;
					height: 177px;
				}
			}
		}

		.steam_game {
			padding-top: 10px;
			.title {
				color: #2d2200;
				font-size: 26px;
				font-weight: bold;
				margin-top: 100px;
				text-align: center;
				margin-bottom: 35px;
			}

			.title2 {
				margin: 4px 0 30px 0;
			}

			.steam_list {
				overflow: hidden;
				padding: 0 30px;
				.item {
					display: block;
					text-align: center;
					background: #f1f1f1;
					width: 213px;
					float: left;
					margin-right: 17px;
					margin-bottom: 36px;
					// box-shadow: 5px -3px 7px #b9b6b6;
					position: relative;
					img {
						display: block;
					}
					.cn {
						position: absolute;
						left: 50%;
						top: 55%;
						margin-left: -63px;
					}
					.tit {
						font-size: 16px;
						color: #ffeabe;
						padding: 10px 0;
					}
					.hao {
						span {
							color: #dfca9d;
							border: 1px solid #dfca9d;
							padding: 1px 5px;
							border-radius: 10px;
							margin: 0 5px;
						}
					}
				}
				.item:hover {
					box-shadow: 1px -1px 22px #080200;
				}
				.mr {
					margin-right: 0;
				}

				.sw_btn {
					display: block;
					height: 45px;
					line-height: 45px;
					color: #ff8700;
					background: #573526 url(/static/images/jdqs/arrow.png) no-repeat 138px center;
				}

				.sw_btn:hover {
					color: #ffa200;
					background: #573526 url(/static/images/jdqs/arrow_hover.png) no-repeat 138px center;
				}
			}
		}
	}

	.footer {
		margin-top: 176px;
		background: #000000;
		padding: 23px 0;
		.cont {
			width: 1200px;
			margin: 0 auto;
			text-align: center;
			.c1 {
				color: #e4e4e4;
				font-size: 14px;
				margin-bottom: 18px;
			}
			.c2 {
				text-align: left;
				padding-left: 315px;
				overflow: hidden;
				.hz {
					float: left;
					span {
						display: block;
						color: #e4e4e4;
						margin-top: 4px;
						font-size: 14px;
					}
				}
				.yz {
					.img1 {
						width: 110px;
						height: 43px;
						padding-left: 15px;
						margin-right: 40px;
					}
					.img2 {
						width: 34px;
						height: 43px;
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/loljch.vue